/** @jsx jsx */
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Navigation, EffectFade } from "swiper";
import { Col, Container, Row } from "react-bootstrap";
import { SliderAboutData } from "@/data";
import { jsx } from '@emotion/react'

import { 
  mainSlider,
  shapeImg,
  infoSlider,
  imageSlider
}  from '../assets/styles/SliderAbout.styles'
import { 
  secTitle,
  subtitle }  from '../assets/styles/layout.styles'

SwiperCore.use([Autoplay, Navigation, EffectFade]);
const SliderAbout = () => {
  const mainSlideOptions = {
    slidesPerView: 1,
    loop: true,
    effect: "fade",
    navigation: {
      nextEl: "#main-slider-next",
      prevEl: "#main-slider-prev",
    },
    pagination: {
      el: "#carousel-pagination",
      type: "bullets",
      clickable: true,
    },
  };
  return (
    <section css={mainSlider}>
      <Swiper {...mainSlideOptions}>
        {SliderAboutData.map(({ image, shape, subTitle, title, highlight, button }, index) => (
          <SwiperSlide key={index}>
            <div
              className="image-layer"
              // style={{ backgroundImage: `url(${image})` }}
            ></div>
            <Container>
              <Row>
                <Col lg={5} md={12}>
                 <div data-aos={"fade-right"} data-aos-delay={"300"} css={infoSlider}>
                  
                    <h3 css={secTitle}>
                      <img css={shapeImg} src={shape} alt=""/>
                      {title}<span>{highlight}</span>
                      </h3>
                    <p css={subtitle}>{subTitle}</p>
                    {/* <Link to={button.url} css={[commonBtn,sliderBtn]}>
                      <span>{button.label}</span>
                    </Link> */}
                 </div>
                </Col>
                <Col lg={7} md={12}>
                  <div data-aos={"fade"} data-aos-delay={"800"} css={imageSlider}>
                    <img src={image} alt="" />
                  </div>
                </Col>
              </Row>
            </Container>
          </SwiperSlide>
        ))}
        {/* <div className="swiper-button-prev" id="main-slider-prev">
          <i className="fa fa-angle-left"></i>
        </div>
        <div className="swiper-button-next" id="main-slider-next">
          <i className="fa fa-angle-right"></i>
        </div> */}
         <div
                className="swiper-pagination"
                id="carousel-pagination"
              ></div>
      </Swiper>
    </section>
  );
};

export default SliderAbout;
